import NextLink from "next/link";

import { IcExternal } from "@jetblue/kit-icons/ic-external";

export type AuthenticatedCallToActionsProperties = {
  links: {
    href: string;
    isExternal: boolean;
    label: string;
    target?: "_blank" | "_self";
  }[];
};
export const AuthenticatedCallToActions = ({
  links,
}: AuthenticatedCallToActionsProperties) =>
  links.length === 0 ? null : (
    <section className="border-b border-medium-gray p-6">
      {links.map((link) => (
        <NextLink
          className="focus-visible:focus-outline flex cursor-pointer items-center text-royal-blue hover:text-core-blue hover:underline [&:not(:first-child)]:mt-4 md:[&:not(:first-child)]:mt-3 [&:not(:last-child)]:mb-4 md:[&:not(:last-child)]:mb-3"
          href={link.href}
          key={link.href}
        >
          <span>{link.label}</span>

          {link.isExternal && <IcExternal className="ml-1 inline size-2" />}
        </NextLink>
      ))}
    </section>
  );
